module.exports = __webpack_public_path__ + "img/aplicacoes_empilhadeiras_SMALL.cdf4ab45.jpg";